var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('PlantForm',{attrs:{"plantId":_vm.plantId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }